import script from "./XIA-Map.vue?vue&type=script&setup=true&lang=js"
export * from "./XIA-Map.vue?vue&type=script&setup=true&lang=js"

import "./XIA-Map.vue?vue&type=style&index=0&id=4ec778f2&lang=css"

const __exports__ = script;

export default __exports__